"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react")); // eslint-disable-next-line react/prop-types


var inputComponent = function inputComponent(_ref) {
  var inputRef = _ref.inputRef,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["inputRef"]);
  return _react["default"].createElement("div", (0, _extends2["default"])({
    ref: inputRef
  }, props));
};

var _default = inputComponent;
exports["default"] = _default;